import { useEffect } from 'react';

export default function BackgroundAccents() {
  useEffect(() => {
    // Create the accent2 div with spans
    const accentDiv = document.createElement('div');
    accentDiv.id = 'accent2';
    accentDiv.className = 'ng-star-inserted';
    
    // Create 5 spans
    for (let i = 0; i < 5; i++) {
      const span = document.createElement('span');
      accentDiv.appendChild(span);
    }
    
    // Add to body
    document.body.appendChild(accentDiv);
    
    // Cleanup on unmount
    return () => {
      const existingAccent = document.getElementById('accent2');
      if (existingAccent) {
        existingAccent.remove();
      }
    };
  }, []);

  return null; // This component doesn't render anything visible
}
